import { Crosshair, Handshake, LayoutGrid, MapPin, Radio, type LucideIcon } from "lucide-react";

/**
 * 5 能力群(营销智脑 IA)—— 首页卡墙 + 74px 图标轨 + 上下文侧栏都按这 5 群铺。
 *
 * ★群是**前端固定壳**(壳的 label / 图标 / 顺序是产品叙事,不该运营改);哪个舱落哪个群、
 * 什么态,是**后端 xb_module_catalog** 的 cluster / status(运营可改不发版)。两者分工清楚:
 * 群壳在这里,舱归属在后端。
 */
export const CLUSTER_ORDER = [
  "content",
  "acquisition",
  "conversion",
  "intelligence",
  "operations",
] as const;

export type CapabilityCluster = (typeof CLUSTER_ORDER)[number];

export interface ClusterMeta {
  /** 群标题 i18n key(common.json)。 */
  labelKey: string;
  /** 群副标 i18n key。 */
  subKey: string;
  /** 74px 轨图标。 */
  railIcon: LucideIcon;
}

/** 群页路由:点大类(首页横滑带「查看全部」/ 轨群图标)落到该群工作台。单源,壳与页共用。 */
export const clusterRoute = (cluster: CapabilityCluster): string => `/g/${cluster}`;

/** 路由 → 群 key(群页 useParams 校验;非法 key 返回 null)。 */
export function clusterFromRoute(key: string | undefined): CapabilityCluster | null {
  return (CLUSTER_ORDER as readonly string[]).includes(key ?? "")
    ? (key as CapabilityCluster)
    : null;
}

export const CLUSTER_META: Record<CapabilityCluster, ClusterMeta> = {
  content: { labelKey: "cluster.content", subKey: "cluster.contentSub", railIcon: LayoutGrid },
  acquisition: {
    labelKey: "cluster.acquisition",
    subKey: "cluster.acquisitionSub",
    railIcon: MapPin,
  },
  conversion: {
    labelKey: "cluster.conversion",
    subKey: "cluster.conversionSub",
    railIcon: Handshake,
  },
  intelligence: {
    labelKey: "cluster.intelligence",
    subKey: "cluster.intelligenceSub",
    railIcon: Crosshair,
  },
  operations: { labelKey: "cluster.operations", subKey: "cluster.operationsSub", railIcon: Radio },
};
